module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }